export const Constants = {
  phoneNumberCountryCode: "+968",
  phoneNumberLen: 8,
  companyName: "سلوى الرواحي",
  contactEmail: "rawahisalwa431@gmail.com",
  operatorAddress: "علاية سمائل، سلطنة عمان",
  source: "oman-cmp-v1",
  owner: process.env.REACT_APP_OWNER_ID || 1,
};
